import React from 'react';
import { Alert } from 'react-bootstrap';
import StaffTable from './StaffTable';
import { LoadingSpinner } from '@/_elements/Loaders';

const UnassignedStaff = ({ staff, isLoading, providerId, onSave }) => {
    return (
        <div className="mt-4">
            {isLoading ? (
                <LoadingSpinner />
            ) : staff.length === 0 ? (
                <Alert variant="info">No unassigned staff members.</Alert>
            ) : (
                <StaffTable staff={staff} unassignedList={true} providerId={providerId} onSave={onSave} />
            )}
        </div>
    );
};

export default UnassignedStaff;
